/* HERLEVÉ motion: soft fade-ins as sections scroll into view. Off for visitors who prefer reduced motion. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sel = [
    '.hv-section .hv-eyebrow', '.hv-section h2', '.hv-intro p',
    '.hv-steps__grid > *', '.hv-car__stage', '.hv-dz__stage', '.hv-dz__group',
    '.hv-founder .hv-photo', '.hv-founder blockquote', '.hv-founder__body',
    '.hv-mosaic__grid > *', '.hv-ways__grid > *', '.hv-band p',
    '.hv-gallery > *', '.hv-apart__grid > *', '.hv-policies__grid > *', '.hv-pair > *',
    '.hv-letter p', '.hv-work > *', '.hv-custom__grid > *', '.hv-cta > *'
  ].join(',');
  var vh = window.innerHeight;
  var els = Array.prototype.slice.call(document.querySelectorAll(sel)).filter(function (el) {
    if (el.closest('.hv-header, .hv-hero, .hv-footer, .hv-form-wrap')) return false;
    return el.getBoundingClientRect().top > vh * 0.9;
  });
  var marked = [];
  els.forEach(function (el) {
    for (var i = 0; i < marked.length; i++) if (marked[i].contains(el)) return;
    marked.push(el);
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  marked.forEach(function (el) {
    var sibs = el.parentNode ? Array.prototype.indexOf.call(el.parentNode.children, el) : 0;
    el.style.transitionDelay = Math.min(sibs, 4) * 90 + 'ms';
    el.classList.add('hv-rv');
    io.observe(el);
  });
})();
